/*eslint-disable multiline-ternary */
import { Col, Row, InputGroup } from 'react-bootstrap';
import useViewAllDocuments from './hooks/useViewAllDocuments';
import { Link } from 'react-router-dom';
import TextInput from 'src/Components/GenericInputText/TextInput';
import { SearchSVG } from '../../img/GlobalSVG';
import {
  SendDocumentIconSVG,
  SendDocumentDisabledIconSVG,
} from '../../img/uploadDocument/uploadDocumentSVG';
import GenericButton from '../../../Components/GenericButton/GenericButton';
import DocumentListTable from './DocumentTable/DocumentListTable';
import CustomPaginationItemsDisplay from '../common/pagination/CustomPaginationItemsDisplay';
import CustomPagination from '../common/pagination';
import './UploadDocument.scss';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import ViewDocumentListSkeleton from './skeleton/ViewDocumentListSkeleton';
import MasterPermissions from '../../api/MasterPermissions';

const ViewAllDocuments = (props) => {
  const {
    pageInfo,
    isNotFound,
    filteredRecords,
    pageSize,
    currentPage,
    totalRecords,
    searchText,
    columnNames,
    displayPaginationMininumCount,
    loadingApiConfig,
    isAPIFailed,
    dataFetching,
    pageSizeHandler,
    paginationHandler,
    onSearch,
  } = useViewAllDocuments();

  return (
    <>
      <div
        className="sr-only"
        role="heading"
        aria-level={1}
        ref={pageInfo}
        tabIndex={0}
      >
        Documents Page
      </div>
      <div className="container-offset">
        <div className="d-flex align-items-center">
          <div className="ml-3">
            <h1 className="content-header" aria-hidden={true}>
              Documents
            </h1>
          </div>
        </div>
      </div>
      <div className="documents-filter-containerr filter-bar-border-top filter-bar-border-bottom mt-2 mb-md-4 mb-xs-3">
        <div className="search-container-filter">
          <Row className="justify-content-between">
            <Col
              xs={12}
              sm={6}
              md={8}
              lg={5}
              className=" border-right-documents py-4"
            >
              <label htmlFor="filterByTitleReference" className="sr-only">
                Search by title
              </label>
              <TextInput
                parentClassName="document-search"
                append={
                  <InputGroup.Text>
                    <SearchSVG.SearchSVG className="primary-text-color" />
                  </InputGroup.Text>
                }
                inputProps={{
                  type: 'text',
                  placeholder: 'Search by Title',
                  className: 'border-0 height-32 mr-1',
                  value: searchText,
                  onChange: onSearch,
                  id: 'filterByTitleReference',
                }}
              />
            </Col>

            <Col
              xs={12}
              sm={6}
              md={4}
              lg={5}
              className="send-document-button py-4"
            >
              {MasterPermissions.CheckPermission('Upload Document') ? (
                <Link to="/admin/upload-document" state={props.preserveData}>
                  <GenericButton
                    variant="primary"
                    tabIndex={0}
                    ariaLabel="Click to go to send document screen"
                  >
                    <span className="mr-2">
                      <SendDocumentIconSVG />
                    </span>
                    Send Document
                  </GenericButton>
                </Link>
              ) : (
                <GenericButton
                  disable={true}
                  buttonDisabled={true}
                  tabIndex={0}
                >
                  <span className="mr-2">
                    <SendDocumentDisabledIconSVG />
                  </span>
                  Send Document
                </GenericButton>
              )}
            </Col>
          </Row>
        </div>
      </div>
      <div className="container-offset">
        {dataFetching || loadingApiConfig ? (
          <ViewDocumentListSkeleton />
        ) : (
          <>
            {isAPIFailed ? (
              <div>
                {isNotFound ? (
                  <div className="document-no-data text-center">
                    <CustomClientError
                      CustomClasses="p-0 m-0"
                      ErrorHeading="No Documents found!"
                      ErrorMessage="We could not find any documents for the selected search.
                try again."
                    />
                  </div>
                ) : (
                  <CustomClientError
                    ErrorHeading="Something went wrong with request!"
                    ErrorMessage="Please try again."
                  />
                )}
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-between mt-4 pl-2 pagination-container">
                  {totalRecords > displayPaginationMininumCount ? (
                    <CustomPaginationItemsDisplay
                      pageSize={pageSize}
                      setPageSize={pageSizeHandler}
                      prefixMessage="Records per page"
                      suffixMessage={`Showing ${
                        currentPage * pageSize - pageSize + 1
                      } - ${
                        pageSize * currentPage < totalRecords
                          ? pageSize * currentPage
                          : totalRecords
                      } of ${totalRecords} results`}
                    />
                  ) : null}

                  <div className="d-flex align-items-center">
                    {totalRecords > displayPaginationMininumCount ? (
                      <CustomPagination
                        className="p-0 m-0"
                        pageSize={pageSize}
                        currentPage={currentPage}
                        totalCount={totalRecords}
                        onPageChange={paginationHandler}
                      />
                    ) : null}
                  </div>
                </div>
                <div role="alert" className="sr-only">{`${
                  filteredRecords?.length
                } record${filteredRecords?.length > 1 ? 's' : ''} found`}</div>
                <div className="document-list-table-admin mt-4 ml-2">
                  <DocumentListTable
                    className="account-table"
                    preserveData={props.preserveData}
                    columns={columnNames}
                    data={filteredRecords}
                    keyField={columnNames}
                    pageSizeCount={pageSize}
                    searchText={searchText}
                  />
                </div>
                <div className="d-flex justify-content-between mt-4 pagination-container-2">
                  {totalRecords > displayPaginationMininumCount ? (
                    <CustomPaginationItemsDisplay
                      pageSize={pageSize}
                      setPageSize={pageSizeHandler}
                      prefixMessage="Records per page"
                    />
                  ) : null}

                  <div className="d-flex align-items-center">
                    {totalRecords > displayPaginationMininumCount ? (
                      <CustomPagination
                        className="p-0 m-0"
                        pageSize={pageSize}
                        currentPage={currentPage}
                        totalCount={totalRecords}
                        onPageChange={paginationHandler}
                      />
                    ) : null}
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ViewAllDocuments;
